<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'

export default {
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    document: Object,
    uuid: { type: String, required: false },
    context: { type: String, required: false },
    contextId: { type: String, required: false },
  },

  data() {
    return {
      selected: false,
      selectedFile: null,
    }
  },

  emits: ['document-to-send', 'document-uploading', 'document-uploaded', 'document-uploading-error'],

  computed: {
    allowedTypes() {
      const supportedExtensions = this.conf.fileExtensionAuthorized.split(',')

      return supportedExtensions.map((extension) => `.${extension}`).join(',')
    },
    documentLabel() {
      return this.selectedFile ? this.selectedFile.name : this.$t('document.clickForAdd')
    },
    inputLabelClass() {
      return {
        'btn ': true,
        'btn-success': this.selected,
        'btn-warning': !this.selected,
      }
    },
  },
  methods: {
    async addDocument(fileList) {
      if (fileList.length === 0) return

      const file = fileList[0]

      // Vérification de la taille du fichier
      if (this.conf.fileMaxSize > 0 && file.size > this.conf.fileMaxSize) {
        let fileMaxSize =
          this.conf.fileMaxSize < 1_000
            ? '1 Ko'
            : this.conf.fileMaxSize / 1_000 < 1_000
              ? `${this.conf.fileMaxSize / 1_000} Ko`
              : `${this.conf.fileMaxSize / 1_000_000} Mo`

        alert(this.$root.$t('document.errorFileMaxSize', { fileMaxSize }))
        return
      }

      // Vérification de l'extension du fichier
      const fileExtensions = this.conf.fileExtensionAuthorized.toLowerCase().split(',')
      const fileExtension = file.name.split('.').pop().toLowerCase()

      if (!fileExtensions.includes(fileExtension)) {
        alert(
          this.$root.$t('document.errorFileExtension', {
            fileExtension: fileExtensions.map((ext) => `.${ext}`).join(', '),
          }),
        )
        return
      }

      // Préparation de l'objet à envoyer
      let documentToSend = {
        typeId: this.document.id,
        context: `AppBundle\\Entity\\${this.context}`,
        contextId: this.contextId,
        uniqid: this.uuid,
        imageFile: {
          filename: file.name,
          file: '',
        },
      }

      this.setUploading(this.document)
      this.handleFileSelection(fileList)
      this.selected = true

      try {
        documentToSend.imageFile.file = await this.readFileAsBase64(file)
        let url = this.uuid ? 'free/documents' : 'documents'

        this.$emit('document-to-send', { doc: documentToSend, link: url })
      } catch (error) {
        alert(this.$t('document.add.error'))
      }
    },

    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => resolve(reader.result.split(',')[1]) // Supprime le préfixe `data:image/png;base64,`
        reader.onerror = () => reject(new Error())

        reader.readAsDataURL(file)
      })
    },

    setUploading(document) {
      document.setUploading()
      this.$emit('document-uploading', document)
    },

    setUploadOk(document, documentUploaded) {
      document.setUploadOk()
      this.$emit('document-uploaded', documentUploaded.document.document)
    },

    setUploadError(document, reason) {
      document.setUploadError(reason)
      this.$emit('document-uploading-error', { document: document, error: reason })
    },

    handleFileSelection(fileList) {
      this.selectedFile = fileList.length > 0 ? fileList[0] : null
    },

    removeDocuments() {
      this.$refs.file.value = ''
      this.selected = false
      this.selectedFile = null
    },
  },
}
</script>
<template>
  <div class="add">
    <div>
      <p :class="inputLabelClass" style="font-weight: 500">
        <i class="fas fa-download"></i> <span>{{ documentLabel }}</span>
      </p>
      <input
        type="file"
        name="file"
        class="input__file--hidden"
        id="document-add"
        ref="file"
        data-multiple-caption="{count} fichiers sélectionnés"
        multiple
        :accept="allowedTypes"
        e2e-input="documentAdd"
        @change="addDocument($event.target.files)"
      />
    </div>
    <span v-if="document.isUploadError()" class="badge-danger badge-lg badge-pill fs-14">
      <i class="fa fa-warning"></i>&nbsp;&nbsp;{{ $t('document.uploadingError') }}
    </span>
  </div>
</template>
